module.exports = __webpack_public_path__ + "media/assets/images/flags/sx-c330c366208ece4a3cd83d52bcc27ac5.svg";